var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useImperativeHandle, useId } from 'react';
import classNames from 'classnames';
import i18n from './i18n/i18n';
import { ErrorFieldMessage } from './message';
var getFieldMessage = function (countryCodeAndNumberFieldMessage, countryCodeFieldMessage, numberFieldMessage) {
    var fieldMessage;
    if (countryCodeAndNumberFieldMessage) {
        fieldMessage = countryCodeAndNumberFieldMessage;
    }
    else if (countryCodeFieldMessage && numberFieldMessage) {
        console.error('You should use countryCodeAndNumberFieldMessage when both countryCode and number contains an error');
    }
    else if (countryCodeFieldMessage) {
        fieldMessage = countryCodeFieldMessage;
    }
    else if (numberFieldMessage) {
        fieldMessage = numberFieldMessage;
    }
    return fieldMessage;
};
export var PhoneNumber = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var numberInputProps = _a.numberInputProps, countryCodeInputProps = _a.countryCodeInputProps, countryCodeFieldMessage = _a.countryCodeFieldMessage, numberFieldMessage = _a.numberFieldMessage, countryCodeAndNumberFieldMessage = _a.countryCodeAndNumberFieldMessage, className = _a.className, extraMargin = _a.extraMargin, isMobileNumber = _a.isMobileNumber, _d = _a.locale, locale = _d === void 0 ? 'nb' : _d;
    var countryRef = useRef(null);
    var numberRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        get country() {
            return countryRef.current;
        },
        get number() {
            return numberRef.current;
        },
    }); });
    var fieldMessage = getFieldMessage(countryCodeAndNumberFieldMessage, countryCodeFieldMessage, numberFieldMessage);
    var numberId = useId();
    var countryCodeId = useId();
    var generatedFieldMessageId = useId();
    var fieldMessageId = React.isValidElement(fieldMessage)
        ? (_b = fieldMessage === null || fieldMessage === void 0 ? void 0 : fieldMessage.props) === null || _b === void 0 ? void 0 : _b.id
        : generatedFieldMessageId;
    var supportedLocales = ['nb', 'nn', 'en'];
    var text = i18n[supportedLocales.indexOf(locale) !== -1 ? locale : 'nb'];
    return (React.createElement("div", { className: classNames('ffe-phone-number', 'ffe-input-group', { 'ffe-input-group--message': fieldMessage }, { 'ffe-input-group--no-extra-margin': !extraMargin }, className) },
        React.createElement("div", { className: "ffe-phone-number__input-group" },
            React.createElement("div", { className: "ffe-phone-number__country-code" },
                React.createElement("label", { className: "ffe-form-label", htmlFor: countryCodeId }, text.COUNTRY_CODE),
                React.createElement("div", { className: "ffe-phone-number__input-group" },
                    React.createElement("span", { className: classNames('ffe-phone-number__plus', 'ffe-default-mode') }, "+"),
                    React.createElement("input", __assign({ ref: countryRef, id: countryCodeId, value: (_c = countryCodeInputProps === null || countryCodeInputProps === void 0 ? void 0 : countryCodeInputProps.value) !== null && _c !== void 0 ? _c : '47', className: classNames('ffe-input-field', 'ffe-phone-number__country-code-input', 'ffe-default-mode'), type: "tel", "aria-invalid": !!(countryCodeFieldMessage ||
                            countryCodeAndNumberFieldMessage), "aria-describedby": !!(countryCodeFieldMessage ||
                            countryCodeAndNumberFieldMessage)
                            ? fieldMessageId
                            : undefined }, countryCodeInputProps)))),
            React.createElement("div", { className: "ffe-phone-number__number" },
                React.createElement("label", { className: "ffe-form-label", htmlFor: numberId }, isMobileNumber
                    ? text.MOBILE_NUMBER
                    : text.PHONE_NUMBER),
                React.createElement("input", __assign({ ref: numberRef, id: numberId, type: "tel", className: classNames('ffe-input-field', 'ffe-phone-number__phone-input', 'ffe-default-mode'), "aria-invalid": !!(numberFieldMessage ||
                        countryCodeAndNumberFieldMessage), "aria-describedby": !!(numberFieldMessage ||
                        countryCodeAndNumberFieldMessage)
                        ? fieldMessageId
                        : undefined }, numberInputProps)))),
        typeof fieldMessage === 'string' && (React.createElement(ErrorFieldMessage, { as: "p", id: fieldMessageId }, fieldMessage)),
        React.isValidElement(fieldMessage) &&
            React.cloneElement(fieldMessage, {
                id: fieldMessageId,
            })));
});
